const ele = document.getElementById('fire-lookout-art');
const cameraId = 'Axis-Aeneas';
const url = `https://caltimes-alertwildfire-scraper-dev.s3-us-west-2.amazonaws.com/${cameraId}/latest.jpg`;

export async function boot() {
  loadImage(url)
    .then((img) => processImage(img))
    .then((data) => stall(data))
    .then((data) => render(data));

  function render(data) {
    let canvas = document.createElement('canvas');
    canvas.width = data.width;
    canvas.height = data.height;
    let ctx = canvas.getContext('2d');
    ctx.canvas.style.imageRendering = 'pixelated';

    // Now draw!
    ctx.globalCompositeOperation = 'source-over';
    ctx.drawImage(data.ditheredImage, 0, 0);

    ctx.fillStyle = 'rgba(128, 38, 192, 0.20)';
    ctx.fillRect(0, 0, data.width, data.height);

    // Clear the element
    clear();

    // Add the canvas to the page
    ele.appendChild(ctx.canvas);

    // Toss in the caption too
    const caption = document.createElement('figcaption');
    caption.innerHTML = 'The latest view from Aeneas Lookout.</figcaption>';
    caption.classList.add('figcaption');
    ele.appendChild(caption);
  }

  function clear() {
    ele.innerHTML = '';
  }
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = '*';
    img.style.imageRendering = 'crisp-edges';
    img.addEventListener('load', () => resolve(img));
    img.addEventListener('error', (err) => reject(err));
    img.src = src;
  });
}

function processImage(img) {
  return new Promise(function (resolve, reject) {
    const data = parseImageData(img);
    resolve(data);
  });
}

function stall(payload) {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(payload), 2000);
  });
}

function parseImageData(img) {
  const width = ele.offsetWidth;
  const widthRatio = width / img.width;
  const fittedWidth = width;
  const fittedHeight = img.height * widthRatio;
  const canvas = document.createElement('canvas');
  canvas.width = fittedWidth;
  canvas.height = fittedHeight;
  let ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, fittedWidth, fittedHeight);
  let data = {
    img: img,
    ctx: ctx,
    width: fittedWidth,
    height: fittedHeight,
  };
  data['ditheredData'] = ditherData(data);
  data['ditheredImage'] = data2image(data['ditheredData']);
  return data;
}

function data2image(imagedata) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  canvas.width = imagedata.width;
  canvas.height = imagedata.height;
  ctx.putImageData(imagedata, 0, 0);
  var image = new Image();
  image.src = canvas.toDataURL();
  return image;
}

function ditherData(data) {
  let GRAYS = 256;
  let thresholds = [];
  for (let i = 0; i < GRAYS; i++) {
    thresholds.push(i < GRAYS >> 1 ? 0 : GRAYS - 1);
  }

  // Clone the image data
  const clone = new ImageData(
    new Uint8ClampedArray(
      data.ctx.getImageData(0, 0, data.width, data.height).data
    ),
    data.width,
    data.height
  );
  function px(x, y) {
    return x * 4 + y * data.width * 4;
  }
  for (let y = 0; y < data.height; y++) {
    for (let x = 0; x < data.width; x++) {
      let oldPixel = clone.data[px(x, y)];
      let grayNew = thresholds[oldPixel];
      let grayErr = (oldPixel - grayNew) >> 3;
      let newPixel = oldPixel > 125 ? 255 : 0;
      clone.data[px(x, y)] = clone.data[px(x, y) + 1] = clone.data[
        px(x, y) + 2
      ] = newPixel;
      clone.data[px(x, y)] = clone.data[px(x, y) + 1] = clone.data[
        px(x, y) + 2
      ] = grayNew;
      [
        [1, 0],
        [2, 0],
        [-1, 1],
        [0, 1],
        [1, 1],
        [0, 2],
      ].forEach(([dx, dy]) => {
        clone.data[px(x + dx, y + dy)] += grayErr;
      });
    }
  }
  return clone;
}
